'use client';

import { sanitizeRichText } from '../lib/rich-text';

export interface RichTextContentProps {
  /** Stored Tiptap HTML. Sanitized here — callers never inject it themselves. */
  html: string;
  className?: string;
  /** Rendered element. Defaults to `div`; use `span` inside inline layouts. */
  as?: 'div' | 'span';
}

/**
 * The only sanctioned way to render stored rich text.
 *
 * Writers sanitize before they store, but rows written before that existed can
 * still hold script tags or `javascript:` links, so every render sanitizes
 * again. Reach for this instead of a hand-rolled `dangerouslySetInnerHTML`.
 */
export function RichTextContent({ html, className, as = 'div' }: RichTextContentProps) {
  const Tag = as;
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: sanitizeRichText(html) }} />;
}
